module.exports = __webpack_public_path__ + "static/video-14c59560fff6c6078d1e009de8bb2dba.jpg";